import { sample } from 'effector';
import {
  downloadSectorsEv,
  MatrixProjectGate,
  SectorsGate,
  setMatrixProjectConSheetFiltersEv,
} from './events.js';
import {
  $sectorsList,
  $MatrixProjectData,
  $MatrixProjectConSheet,
  $MatrixProjectConSheetFilters,
} from './stores.js';
import {
  downloadSectorsDataFx,
  getMatrixProjectDataFx,
  getMatrixProjectConSheetFx,
  getSectorsDataFx,
} from './effects.js';
import queryString from 'query-string';

$sectorsList
  .on(getSectorsDataFx.doneData, (_, payload) => {
    if (window.location.pathname.includes('/matrix/works')) {
      return payload;
    } else {
      let childrenField;
      if (window.location.pathname.includes('/matrix/products'))
        childrenField = 'manufacturers';
      if (window.location.pathname.includes('/matrix/services'))
        childrenField = 'services';
      if (window.location.pathname.includes('/matrix/works'))
        childrenField = 'licences';
      if (window.location.pathname.includes('/matrix/projects'))
        childrenField = 'projects';

      return {
        ...payload,
        data: payload.data.map((item, index) => {
          return {
            ...item,
            key: `sector_${index}_item`,
            [childrenField]: item[childrenField]
              ? item[childrenField].map((elem, elemIndex) => {
                  return {
                    ...elem,
                    key: `${childrenField}_${elem.id}_${index}_${elemIndex}`,
                  };
                })
              : [],
          };
        }),
      };
    }
  })
  .reset(SectorsGate.close);

$MatrixProjectData
  .on(getMatrixProjectDataFx.doneData, (_, payload) => payload)
  .reset(MatrixProjectGate.close);

$MatrixProjectConSheet
  .on(getMatrixProjectConSheetFx.doneData, (_, payload) => payload)
  .reset(MatrixProjectGate.close);

$MatrixProjectConSheetFilters
  .on(setMatrixProjectConSheetFiltersEv, (state, payload) => ({
    ...state,
    ...payload,
  }))
  .reset(MatrixProjectGate.close);

sample({
  clock: SectorsGate.state,
  filter: (gate) =>
    Object.hasOwn(gate, 'search') &&
    gate.sector &&
    Object.hasOwn(gate, 'sector'),
  target: getSectorsDataFx,
});

sample({
  clock: downloadSectorsEv,
  target: downloadSectorsDataFx,
});

sample({
  clock: MatrixProjectGate.open,
  filter: (gate) => !!(gate && gate.id),
  fn: (gate) => +gate.id,
  target: getMatrixProjectDataFx,
});

sample({
  clock: $MatrixProjectData.updates,
  filter: (data) => !!(data && data.name),
  fn: (data) => ({ project: data.name }),
  target: setMatrixProjectConSheetFiltersEv,
});

sample({
  clock: $MatrixProjectConSheetFilters.updates,
  filter: (obj) => obj && Object.keys(obj).length > 0,
  fn: (filters) =>
    queryString.stringify(filters, { skipEmptyString: true, skipNull: true }),
  target: getMatrixProjectConSheetFx,
});
